import {useEffect, useRef} from 'react';
import {useArrivalProperty} from 'components/arrival';
import {useReservation} from 'context/reservation';
import {useGuestGroup} from 'hooks/useGuestGroup';
import {useBookingFoundHandoffStore} from 'pages/SearchReservation/useBookingFoundHandoffStore';

function useOpenGuestCountBlock(shouldOpen: boolean) {
  const {data: reservation} = useReservation();
  const {guestGroup} = useGuestGroup();
  const {isLoading: isPropertyLoading} = useArrivalProperty();
  const openHandoff = useBookingFoundHandoffStore(state => state.open);
  const hasOpened = useRef(false);

  useEffect(
    function openOnceThePropertyIsKnown() {
      const isAlreadyOpen = Boolean(useBookingFoundHandoffStore.getState().handoff);

      if (
        !shouldOpen ||
        isPropertyLoading ||
        !reservation ||
        hasOpened.current ||
        isAlreadyOpen
      ) {
        return;
      }

      hasOpened.current = true;
      openHandoff({
        reservation: {...reservation, guest_group: guestGroup},
        guestName: reservation.default_leader_full_name,
      });
    },
    [shouldOpen, isPropertyLoading, reservation, guestGroup, openHandoff],
  );
}

export {useOpenGuestCountBlock};
